export default __webpack_public_path__ + "static/media/ACCOUNTBG.fd269dfe.svg";